import styled from 'styled-components';

export const SchoolContainer = styled.div`
  padding-left: 195px;
  padding-top: 51px;
  @media (max-width: 971px) {
    padding-left: 65px;
  }
`;
